<div class="modal-overlay">
    <div class="card mx-auto modal-lg border-0">
        <div class="card-header bergh-bg-primary text-white h5">
            Uploaden
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="input-group file-upload">
                        <input type="file" class="file-upload-btn form-control"
                            title="kies afbeelding om te uploaden" (change)="onSelectFile($event)">
                        <div class="form-control file-upload-file d-flex align-items-center justify-content-center">
                            {{fileName!=''?fileName:'Zet het bestand hier neer of klik om het bestand te selecteren'}}
                        </div>
                    </div>
                    <small class="text-danger">Opmerking: de bestandsgrootte moet kleiner zijn dan 15 MB</small>

                </div>
            </div>
        </div>
        <div class="card-footer bg-white d-flex justify-content-end">
            <button class="btn btn-secondary mr-2" id="btn-cancel" type="button" (click)="cancel.emit()">Annuleren</button>
            <button class="btn bergh-btn-secondary text-white" id="btn-save" type="submit" [disabled]="fileName === ''" (click)="onSubmit()">Opslaan</button>
        </div>
    </div>
</div>


